import gql from 'graphql-tag';

export const CMS_QUERY_PROPERTIES_BY_LANDLORD = gql`
  query CMS_queryPropertyByLandlordIds(
    $landlordIds: [ID]
    $pageNumber: Int = 1
    $pageSize: Int = 10
    $name: String
  ) {
    properties(
      name: $name
      landlordIds: $landlordIds
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      edges {
        node {
          name
          id
          landlord {
            name
          }
        }
      }
    }
  }
`;
